export const FREE_HOST = "https://mobile.free.fr";
export const FREE_ENDPOINT = "/account/v2/api/SI";
export const FREE_HOST_WITH_ENDPOINT = FREE_HOST + FREE_ENDPOINT;